import { default as UserDetails } from "./UserDetails";
export default UserDetails;
